function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPocAtmMachineFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3v6h28V3H2zM1 1a1 1 0 00-1 1v8a1 1 0 001 1h30a1 1 0 001-1V2a1 1 0 00-1-1H1z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 11v4h14v-4H9zM8 9a1 1 0 00-1 1v6a1 1 0 001 1h16a1 1 0 001-1v-6a1 1 0 00-1-1H8z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11v18h22V11H5zM4 9a1 1 0 00-1 1v20a1 1 0 001 1h24a1 1 0 001-1V10a1 1 0 00-1-1H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21H7v-2h8v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.41 8H10.24l1.32-4h1.485l1.32 4h-1.172l-.875-2.898h-.031L11.41 8zm-.218-1.578h2.203v.812h-2.203v-.812zM14.135 4.875V4h3.476v.875h-1.203V8h-1.07V4.875h-1.203zM18.02 4h1.352l.93 2.266h.046L21.278 4h1.351v4h-1.062V5.687h-.031l-.891 2.282h-.64l-.891-2.297h-.032V8H18.02V4zM19 20a1 1 0 11-2 0 1 1 0 012 0zM22 20a1 1 0 11-2 0 1 1 0 012 0zM25 20a1 1 0 11-2 0 1 1 0 012 0zM25 23a1 1 0 11-2 0 1 1 0 012 0zM22 23a1 1 0 11-2 0 1 1 0 012 0zM19 23a1 1 0 11-2 0 1 1 0 012 0zM19 26a1 1 0 11-2 0 1 1 0 012 0zM22 26a1 1 0 11-2 0 1 1 0 012 0zM25 26a1 1 0 11-2 0 1 1 0 012 0z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 21v4h2v-4h-2zm-1-2a1 1 0 00-1 1v6a1 1 0 001 1h4a1 1 0 001-1v-6a1 1 0 00-1-1H9z",
    fill: props.color
  }));
}

export default SvgIconPocAtmMachineFilled;